// L3 本站代理模式静态预览(landing_type=site_agent 时显示)。纯展示,无 mutation。
import { Server } from 'lucide-react'

export function LandingProxyPreview() {
  return (
    <div
      className="rounded-lg border border-gray-200 bg-gray-50 p-4"
      data-testid="Ye71I-proxy-preview"
    >
      <p className="mb-1 flex items-center gap-2 text-sm font-medium text-gray-700">
        <Server className="h-4 w-4 text-blue-600" />
        L3 代理跳转模式：跳本站代理
      </p>
      <p className="font-mono text-xs text-gray-500">
        用户访问 charlie.agent.com → 跳到本站 alice.dogdisk.com，带 referrer cookie
      </p>
      <p className="mt-2 text-[11px] text-gray-400">
        本模式无需配置自定义域名 → 减少 DNS 解析开销 + 自动 CDN
      </p>
    </div>
  )
}
